module.exports = __webpack_public_path__ + "static/tiktok-to-be-opened-bb4a552e9543ed778cb908aafba1b359.png";